const Joi = require('joi')
const fields = require('../fields')

const getCexOrdersSchema = Joi.object({
    pair: fields.objectIdField.required().label('Pair'),
});

module.exports = getCexOrdersSchema;